export enum INotificationPositionTypes {
  BOTTOM_LEFT = 'bottomLeft',
  BOTTOM_RIGHT = 'bottomRight',
  TOP_LEFT = 'topLeft',
  TOP_RIGHT = 'topRight',
  CENTER = 'center',
}

export enum INotificationContentTypes {
  ATTENDEE_DELETION = 'ATTENDEE_DELETION',
  ATTENDEE_DELETION_LANDING_PAGE = 'ATTENDEE_DELETION_LANDING_PAGE',
  LOBBY_REDIRECT = 'LOBBY_REDIRECT',
  CUSTOM_NOTIFICATION = 'CUSTOM_NOTIFICATION',
}
export interface INotificationTextProps {
  position: INotificationPositionTypes;
  isVisible: boolean;
  contentType: INotificationContentTypes;
  redirectLink?: URL;
  durationTime?: number;
  message?: string;
}
